module.exports = "img/03b381.887c3ca.png";